export default "__VITE_ASSET__B1kC2Ok___"